export const DEFAULT_CTA_TEXT = [
    {
        name: 'Shop Now',
        value: 'SHOP_NOW',
    },
    {
        name: 'Buy Now',
        value: 'BUY_NOW',
    },
    {
        name: 'Order Now',
        value: 'ORDER_NOW',
    },
    {
        name: 'Book Now',
        value: 'BOOK_NOW',
    },
    {
        name: 'Apply Now',
        value: 'APPLY_NOW',
    },
    {
        name: 'See More',
        value: 'SEE_MORE',
    },
    {
        name: 'View More',
        value: 'VIEW_MORE',
    },
    {
        name: 'Show More',
        value: 'SHOW_MORE',
    },
    {
        name: 'Learn More',
        value: 'LEARN_MORE',
    },
    {
        name: 'Read More',
        value: 'READ_MORE',
    },
    {
        name: 'Add to Cart',
        value: 'ADD_TO_CART',
    },
    {
        name: 'RSVP',
        value: 'RSVP',
    },
    {
        name: 'Donate',
        value: 'DONATE',
    },
    {
        name: 'Sign Up',
        value: 'SIGN_UP',
    },
]

export const DEFAULT_CTA_BTN = "View More"